import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBed, FaBath, FaRulerCombined, FaCar, FaEdit } from 'react-icons/fa';
import './ImovelCard.css';

const ImovelCard = ({ imovel, onEdit, showEditButton = false }) => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('token');
  
  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0
    }).format(price);
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onEdit) {
      onEdit(imovel);
    } else {
      navigate('/dashboard', { state: { editImovel: imovel.id, activeTab: 'imoveis' } });
    }
  };

  return (
    <div className="imovel-card-wrapper">
      {isLoggedIn && showEditButton && (
        <button 
          className="imovel-card-edit-btn"
          onClick={handleEditClick}
          title="Editar imóvel"
        >
          <FaEdit />
        </button>
      )}
      <Link to={`/imovel/${imovel.id}`} className="imovel-card">
      <div className="imovel-card-image">
        {imovel.fotos && imovel.fotos.length > 0 ? (
          <img src={imovel.fotos[0]} alt={imovel.descricao} />
        ) : (
          <div className="imovel-card-placeholder">
            <span>Sem foto</span>
          </div>
        )}
        {imovel.destaque && <span className="badge-destaque">Destaque</span>}
        {imovel.lancamento && <span className="badge-lancamento">Lançamento</span>}
      </div>

      <div className="imovel-card-content">
        <div className="imovel-card-header">
          <span className="imovel-codigo">Cód: {imovel.codigo}</span>
          <span className="imovel-tipo">{imovel.tipo}</span>
        </div>

        <div className="imovel-card-info">
          {imovel.quartos && <span><FaBed /> {imovel.quartos}</span>}
          {imovel.banheiros && <span><FaBath /> {imovel.banheiros}</span>}
          {(imovel.area_construida || imovel.area) && <span><FaRulerCombined /> {imovel.area_construida || imovel.area}m²</span>}
          {(imovel.garagem || imovel.vagas) > 0 && <span><FaCar /> {imovel.garagem || imovel.vagas}</span>}
        </div>

        <p className="imovel-card-descricao">{imovel.descricao}</p>

        <div className="imovel-card-footer">
          <span className="imovel-preco">
            {imovel.operacao === 'locacao' 
              ? `${formatPrice(imovel.preco)} / mês`
              : formatPrice(imovel.preco)
            }
          </span>
          <span className="imovel-localizacao">
            {imovel.bairro}, {imovel.cidade} - {imovel.estado}
          </span>
        </div>
      </div>
    </Link>
    </div>
  );
};

export default ImovelCard;

